import { render, staticRenderFns } from "./NotificationsSnackbar.vue?vue&type=template&id=39bc86ea&scoped=true&"
import script from "./NotificationsSnackbar.vue?vue&type=script&lang=ts&"
export * from "./NotificationsSnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsSnackbar.vue?vue&type=style&index=0&id=39bc86ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bc86ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
